export enum Breakpoint {
  XXS = 320,
  XS = 480,
  SM = 576,
  MD = 768,
  LG = 992,
  XL = 1200,
}
